export default "__VITE_PUBLIC_ASSET__156cb8ce__"